import SparkMD5 from 'spark-md5'
import common from "@common/common";
import { reactive } from 'vue';

class Upload{
    constructor(config){
        const defaultConfig = {
            multipleUpload: false,
            chunkSize: 10,
            limit: 6,
            maxFileLimit: 3,
            autoUpload: true
        }
        this.setReady = () => {}
        this.setUpload = () => {}
        this.setProgress = () => {}
        this.setComplete = () => {}
        this.setAllComplete = () => {}
        this.setError = () => {}
        this.setCancel = () => {}
        this.setHashProgress = () => {}
        this.multiList = []
        this.user = ''
        this.config = {...defaultConfig, ...config}
        if(config.noAuto){
            this.config.autoUpload = false
        }
        this.fileList = []
        this.worker = null
        this.nowUploading = 0
        this.config.limit = config.max_part_num
        this.init()
    }

    cancelUpload(tid) {
        this.fileList.forEach(file => {
            if(file.tid == tid){
                file.source.abort();

                this.fileList = this.fileList.filter(el => {
                    return el.tid != tid
                })

                this.setCancel(tid, file.token)
            }
        })
    }

    timestampToDateTime(timestamp) {
        // 创建一个Date对象，传入时间戳（单位通常为毫秒）
        const date = new Date(timestamp);
    
        // 获取年、月、日、小时、分钟、秒
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的，所以要加1，并添加前导零
        const day = String(date.getDate()).padStart(2, '0');
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');
        const second = String(date.getSeconds()).padStart(2, '0');
    
        // 拼接成所需格式的字符串
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }

    calculateChunkSize(file) {
        let size = 10
        if(file.size < 1024 * 1024 * 1024){
            size = 10
        }else if(file.size > 5 * 1024 * 1024 * 1024){
            size = 100
        }else{
            size = 50
        }

        console.log(this.config.max_part_size)

        if(size > this.config.max_part_size){
            size = this.config.max_part_size
        }

        return size
    }

    singleHash(file) {
        return new Promise((resolve, reject) => {
            const spark = new SparkMD5.ArrayBuffer();
            let cur = 0
            const chunks = []
            const offset = file.size
            const mid = cur + Math.floor(offset / 2);
            const end = cur + offset;
            chunks.push({file: file.slice(cur, cur + 2)});
            chunks.push({file: file.slice(mid, mid + 2)});
            chunks.push({file: file.slice(end - 2, end)});

            let count = 0;
            const loadNext = index => {
                const reader = new FileReader();
                reader.readAsArrayBuffer(chunks[index].file);
                reader.onload = e => {
                    count++;
                    spark.append(e.target.result);
                    if (count === chunks.length) {
                        resolve({
                            fileHash: spark.end()
                        })
                    } else {
                        loadNext(count);
                    }
                };
            };
            loadNext(0);
        })
    }

    init() {
        try {
            let id = document.getElementById(this.config.id);
            let fileInput = document.createElement('input');
            fileInput.style.position = 'absolute';
            fileInput.style.top = '-9999px';
            fileInput.setAttribute('type', 'file');
            if(this.config.allowedFileTypes.length > 0){
                let arr = []
                this.config.allowedFileTypes.forEach(el => {
                    arr.push('.'+el)
                })
                console.log(arr)
                fileInput.setAttribute('accept', arr.join(','));
            }
            if(this.config.multipleUpload){
                fileInput.setAttribute('multiple', 'multiple');
            }
            id.appendChild(fileInput);
            id.addEventListener('click',() => {
                fileInput.click();
            })
            fileInput.addEventListener('change', this.handleFile.bind(this));
        } catch (error) {
            console.log(error)
        }
    }
    
    async handleFile(e) {
        if (!e || !e.target || !e.target.files || !e.target.files.length) {
            this.setError({
                msg:'文件为空!',
                tid: ''
            });
            return;
        }

        const list = []

        const files = e.target.files;

        for (let index = 0; index < files.length; index++) {
            let file = files[index];
            let ext = file.name.split('.').pop().toLowerCase();
            let tid = 'tid' + new Date().getTime() + common.create32();
            if (!this.config.allowedFileTypes.includes(ext)) {
                this.setError({
                    msg: `文件"${file.name}"格式不符合要求!`,
                    tid: tid
                });
            }else{

                list.push({
                    tid: tid,
                    chunk: [],
                    size: file.size,
                    name: file.name,
                    type: file.type,
                    hash: '',
                    file: file,
                    lastModified: this.timestampToDateTime(file.lastModified),
                    chunkSize: this.calculateChunkSize(file)
                })
            }
        }

        // let id = document.getElementById(this.config.id);
        let id = document.querySelector('#'+this.config.id+' > input')
        id.value = ''
        console.log(id)

        if(list.length > 0) {
            console.log('list----',list)
            this.setReady(list)

            if(this.config.autoUpload){
                this.handleHash(list)
            }
            
        }
        

    }

    clearFileList(tid) {
        this.fileList = this.fileList.filter(val => {
            return val.tid != tid
        })
    }

    getToken(fileObj) {
        let num = fileObj.fileChunk.length
        let subject_id = this.config.subjectConfig && this.config.subjectConfig.subject_id ? this.config.subjectConfig.subject_id : ''
        let subject_type = this.config.subjectConfig && this.config.subjectConfig.subject_type ? this.config.subjectConfig.subject_type : ''
        return new Promise((resolve, reject) => {
            let info = {
                file_name: fileObj.name,
                client_md5: fileObj.hash,
                file_size: fileObj.size,
                part_num_all: num,
                last_modify_datetime: fileObj.lastModified,
                part_size: fileObj.chunkSize * 1024 * 1024,
                subject_id: subject_id,
                subject_type: subject_type
            }
            common.myFetch('/index.php?r='+this.config.token_url, info).then(r => {
                console.log('getToken',r)
                if (r) {
                    if(r.is_finish){
                        r.source = fileObj.source
                        this.uploadComplete(r).then(res => {
                            if(res){
                                let result = Object.assign(fileObj, res)
                                this.setComplete(result)
                                this.setAllComplete('allComplete')

                                this.fileList = this.fileList.filter(val => {
                                    return val.tid != fileObj.tid
                                })

                                resolve({token: r.token, list: [], nowPercent: 0})
                            }
                        }).catch(err => {
                            // clearFileList(fileObj.tid)
                            this.fileList = this.fileList.filter(val => {
                                return val.tid != fileObj.tid
                            })

                            reject(err)
                            this.setError({
                                msg: err,
                                tid: fileObj.tid,
                                token: r.token
                            })
                        })
                    }else{
                        console.log(654321)
                        let list = []
                        let nowPercent = 0
                        if(r.uploaded_part_num.length > 0 && r.uploaded_part_num.length != r.part_num){
                            list = fileObj.fileChunk
                            console.log(123123,r.uploaded_part_num.length,num)
                            nowPercent = Number(((r.uploaded_part_num.length / num)*100).toFixed(2))
                            for (let index = 0; index < r.uploaded_part_num.length; index++) {
                                const element = r.uploaded_part_num[index];
                                list = list.filter(item => {
                                    return item.index != element
                                })
                            }
                        }else{
                            list = fileObj.fileChunk
                        }

                        console.log(list)
                        
                        resolve({token: r.token, list: list, nowPercent: nowPercent})
                    }
                }
            }).catch(err => {
                reject('获取Token失败')
                this.setError({
                    msg: '获取Token失败',
                    tid: fileObj.tid
                })
            });
        })
    }

    async handleHash(files) {
        for (let index = 0; index < files.length; index++) {
            const source = new AbortController();
            const fileObj = files[index]
            fileObj.source = source
            this.fileList.push(fileObj)
            const file = fileObj.file;
            const sampleChunk = await this.createSampleChunk(file,fileObj.chunkSize)
            const hash = await this.calculateHash(sampleChunk,file.name)
            fileObj.hash = hash
            fileObj.sampleChunk = sampleChunk
            
            const fileChunk = await this.createChunk(file,hash,fileObj.chunkSize)
            fileObj.fileChunk = fileChunk
            fileObj.file = null

            console.log('hashComplete')

            if (source.signal.aborted) return

            try {
                let {token, list, nowPercent} = await this.getToken(fileObj)

                console.log(token, list, nowPercent)

                if(list.length > 0) {
                    fileObj.token = token
                    fileObj.nowPercent = nowPercent
                    fileObj.fileChunk = list
                    fileObj.progress = 0
                    
                    const chunk = await this.setAjax(fileObj,source) 

                    console.log(chunk)

                    // return false;

                    fileObj.chunk = chunk             

                    fileObj.retryNum = 0

                    this.setUpload(fileObj)

                    if(this.fileList.length > 1) {
                        this.multiFileUpload(fileObj)
                    }else{
                        this.singleFileUpload(fileObj).then(res => {
                            this.uploadComplete(fileObj).then(r => {
                                if(r){
                                    let result = Object.assign(fileObj, r)
                                    this.setComplete(result)
                                    this.setAllComplete('allComplete')
                                }
                            }).catch(err => {
                                this.setError({
                                    msg: err,
                                    tid: fileObj.tid,
                                    token: fileObj.token
                                })
                            })
                        }).catch(err => {
                            this.setError({
                                msg: err,
                                tid: fileObj.tid,
                                token: fileObj.token
                            })
                        })
                    }
                }
            }catch (e) {
                console.log(e)
                this.setError({
                    msg: '上传失败',
                    tid: fileObj.tid,
                    token: fileObj.token
                })
            }
        }
    }

    async uploadComplete(fileObj) {
        return new Promise((resolve, reject) => {
            console.log()
            if(fileObj.source.signal.aborted){
                reject('合并失败')
            }else{
                let info = {
                    token: fileObj.token
                }
                common.myFetch('/index.php?r='+this.config.check_url, info).then(r => {
                    if (r) {
                        resolve(r)
                    }
                }).catch(err => {
                    reject('合并失败')
                });
            }
        })
    }

    singleFileUpload(file) {
        console.log(file)
        return new Promise((resolve, reject) => {
            // 请求数量记录，默认为 0
            let count = 0;
            let num = 0;
            let max = file.chunk.length

            console.log('max', max)

            file.source.signal.addEventListener("abort", () => {
                // 触发了取消事件就执行取消逻辑
                if (file.source.signal.aborted) {
                    reject()
                }
            });

            // 递归调用，请求接口数据
            const run = () => {
                console.log(1)
                // 接口每调用一次，记录数加 1
                count++;
                let p = file.chunk.shift();
                p.fn().then((res) => {
                    num++;
                    // 接口调用完成，记录数减 1
                    count--;

                    this.setProgress({
                        tid: file.tid,
                        type: 'upload',
                        name: file.name,
                        progress: file.nowPercent + Math.floor(num / max * 100) * ((100-file.nowPercent) * 0.01),
                        size: file.size
                    })
                    if (!file.chunk.length && !count) {
                        // 这里可以对所有接口返回的数据做处理，以便输出
                        this.setProgress({
                            tid: file.tid,
                            type: 'upload',
                            name: file.name,
                            progress: 100,
                            size: file.size
                        })
                        resolve({
                            name: file.name,
                            progress: 100,
                            url: ''
                        });

                        this.fileList = this.fileList.filter(val => {
                            return val.tid != file.tid
                        })
                    }   
                    // prmiseQueue 长度不为 0 且记录小于限制的数量时递归调用
                    if (file.chunk.length && count < this.config.limit) {
                        console.log('limitContinue')
                        run();
                    }
                }).catch((err)=>{
                    console.log(err)
                    num --
                    count --
                    // console.log(err,p.retryNum)
                    if(p.retryNum >= 2){
                        this.fileList = this.fileList.filter(val => {
                            return val.tid != file.tid
                        })
                        reject(err)
                        file.source.abort()
                    }else{
                        p.retryNum++
                        file.chunk.unshift(p)

                        // if (count == 0) {
                        //     run();
                        // }
                        if (file.chunk.length && count < this.config.limit) {
                            console.log('errRun')
                            run();
                        }
                    }

                    // console.log(123123)
                    
                    // this.setError(err);
                })
            };
            
            // 根据 limit 并发调用
            for (let i = 0; i < Math.min(max, this.config.limit); i++) {
                console.log('limit',i)
                if(file.source.signal){
                    if(!file.source.signal.aborted){
                        run();
                    }
                }
            }
        })
    }

    async multiFileUpload(file) {
        if(this.nowUploading == 0){
            this.nowUploading++
            this.singleFileUpload(file).then(res => {
                this.nowUploading--
                if(this.multiList.length > 0){
                    const p = this.multiList.shift();
                    this.multiFileUpload(p)
                }else{
                    this.setAllComplete('allComplete')
                }
                this.uploadComplete(file).then(r => {
                    if(r){
                        let result = Object.assign(file, r)
                        this.setComplete(result)
                    }
                }).catch(err => {
                    this.setError({
                        msg: err,
                        tid: file.tid,
                        token: file.token
                    })
                })
            }).catch(err => {
                console.log(123)
                this.nowUploading--
                if(this.multiList.length > 0){
                    const p = this.multiList.shift();
                    this.multiFileUpload(p)
                }else{
                    this.setAllComplete('allComplete')
                }
                this.setError({
                    msg: err,
                    tid: file.tid,
                    token: file.token
                })
            })
        }else{
            this.multiList.push(file)
        }
    }

    calculateHash(fileChunkList,name) {
        return new Promise((resolve) => {
          this.worker = new Worker('/md5/hash.js');
          this.worker.postMessage({ fileChunkList });
          this.worker.onmessage = (e) => {
            const { percentage, hash } = e.data;
            // console.log(percentage)
            this.setHashProgress({
                type: 'hash',
                name: name,
                progress: percentage
            })
            if (hash) {
              resolve(hash);
            }
          };

            // const spark = new SparkMD5.ArrayBuffer();
            // let percentage = 0;
            // let count = 0;
            // const loadNext = index => {
            //     const reader = new FileReader();
            //     reader.readAsArrayBuffer(fileChunkList[index].file);
            //     reader.onload = e => {
            //         count++;
            //         spark.append(e.target.result);
            //         if (count === fileChunkList.length) {
            //             resolve(spark.end());
            //         } else {
            //             percentage += 100 / fileChunkList.length;
            //             this.setHashProgress({
            //                 type: 'hash',
            //                 name: name,
            //                 progress: percentage
            //             })
            //             loadNext(count);
            //         }
            //     };
            // };
            // loadNext(0);
        });
    }

    setAjax(fileObj,source) {
        let upload_url = this.config.upload_url
        let max_expire_time = Number(this.config.max_expire_time)

        let chunk = []

        console.log(444,fileObj,this.config.max_expire_time)

        fileObj.fileChunk.forEach(el => {
            const formData = new FormData()
            formData.append('file', el.cFile)
            formData.append('part_num', el.index)
            formData.append('token', fileObj.token)
            formData.append('md5', el.fileHash)
            formData.append('file_size', el.cFile.size)
            formData.append('part_size', fileObj.chunkSize * 1024 * 1024)
            // chunkSize
            function fn () {
                return new Promise((resolve, reject) => {
                    
                    let userKeys = common.userKeys()

                    for (const key in userKeys) {
                        if (Object.hasOwnProperty.call(userKeys, key)) {
                            formData.append(key, userKeys[key]);
                        }
                    }

                    const apiRoot = process.env.NODE_ENV === "development" ? "" : window.location.origin;
                    var xhr = new XMLHttpRequest();
                    xhr.open("POST", apiRoot + "/index.php?r="+upload_url, true);
                    // xhr.setRequestHeader("Content-Type", "multipart/form-data");
                    // console.log(Number(this.config.max_expire_time))
                    xhr.timeout = Number(max_expire_time) || 20000;
                    xhr.onload = function() {
                        if (xhr.status === 200) {
                            console.log(xhr.responseText)
                            let responseText = JSON.parse(xhr.responseText)
                            // console.log(responseText)
                            if(responseText && responseText.result && responseText.result.success == true){
                                resolve(true)
                            }else{
                                reject("文件上传失败")
                            }
                        } else {
                            reject("文件上传失败：" + xhr.statusText)
                        }
                    };

                    xhr.ontimeout = function() {
                        reject("文件上传过程中发生错误")
                    };

                    xhr.onerror = function() {
                        reject("文件上传过程中发生错误")
                    };

                    xhr.send(formData);

                    if(source.signal){
                        if (source.signal.aborted) {
                            xhr.abort();
                            reject("请求取消");
                            xhr = null;
                        } else {
                            // 监听 abort 事件
                            source.signal.addEventListener("abort", () => {
                                console.log(123123)
                                // 触发了取消事件就执行取消逻辑
                                if (source.signal.aborted) {
                                    xhr.abort();
                                    reject("请求取消");
                                    xhr = null;
                                }
                            });
                        }
                    }
                })  
            }

            console.log(fn)

            chunk.push({fn: fn,retryNum: 0})
        });

        console.log(chunk)

        return chunk
    }

    async createChunk(file,hash,chunkSize,source,token) {
        console.log(chunkSize)
        const chunkList = [];
        const offset = chunkSize * 1024 * 1024;
        let cur = 0; 
        let index = 0;
        while (cur < file.size) {

            let cFile = file.slice(cur, cur + offset)
            let { fileHash } = await this.singleHash(cFile)

            chunkList.push({
                cFile: cFile,
                index: index,
                name: hash+'_'+index,
                fileHash: fileHash
            });

            index++
            cur += offset;
        }
        return chunkList;
    }

    createSampleChunk(file,chunkSize){
        // 文件大小
        const size = file.size;
        const offset = chunkSize * 1024 * 1024;
        let chunks = [{file: file.slice(0, offset)}];
        // 前面10mb的数据
        let cur = offset;
        while (cur < size) {
          // 最后一块全部加进来
          if (cur + offset >= size) {
            chunks.push({file: file.slice(cur, cur + offset)});
          } else {
            // 中间的 前中后去两个字节
            // let fileChunk = []
            const mid = cur + Math.floor(offset / 2);
            const end = cur + offset;
            chunks.push({file: file.slice(cur, cur + 2)});
            chunks.push({file: file.slice(mid, mid + 2)});
            chunks.push({file: file.slice(end - 2, end)});
          }
          // 前取两个字节
          cur += offset;
        }
  
        return chunks
    }

    onReady(callback) {
        this.setReady = callback
    }

    onUpload(callback) {
        this.setUpload = callback
    }

    onhashProgress(callback) {
        this.setHashProgress= callback
    }

    onAllComplete(callback) {
        this.setAllComplete= callback
    }

    onProgress(callback) {
        this.setProgress = callback
    }

    onComplete(callback) {
        this.setComplete = callback
    }

    onError(callback) {
        this.setError = callback
    }

    onCancel(callback) {
        this.setCancel = callback
    }
}

export default Upload